import React from 'react'
import { Anchor } from '@mantine/core'
import { CHAIN_INFO_LIST, CHAIN_CONFIG } from '@/config'
import { useSelectedDenom } from '../../../../contexts/denom'

const ChainAssetUrl: React.FC = () => {
  const [denom] = useSelectedDenom()

  const chainInfo = CHAIN_INFO_LIST[denom]

  const chainConfig = CHAIN_CONFIG[denom]

  if (!chainConfig.assetsUrl) {
    return <span>{chainInfo.chainName}</span>
  }

  return (
    <Anchor href={chainConfig.assetsUrl} target="_blank" underline sx={{ color: 'inherit' }}>
      {chainInfo.chainName}
    </Anchor>
  )
}

export { ChainAssetUrl }
